import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserTrackerConsent } from '../models/userTrackConsent.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BrokerDetail, BrokerService } from './broker.service';
import { OptInOutModel } from '../models/optInOut.model';
import { PolicyHolder } from '../models/policyHolder.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MercuryService {

  private httpClient = inject(HttpClient)
  private brokerService = inject(BrokerService)

  broker!: BrokerDetail

  constructor() { 
    this.broker = this.brokerService.getBrokerDetailFromDomain()
  }

  getHistory(searchValue: string): Observable<UserTrackerConsent[]>{

    return this.httpClient.get<UserTrackerConsent[]>(`${environment.mercury.function.address}/getHistory?code=${environment.mercury.function.code}&searchValue=${searchValue}&brokerId=${this.broker.brokerId}`)

  }

  getToken() : Observable<any>{
    const customHeaders = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded');

    const urlencoded = new URLSearchParams();

    urlencoded.append("grant_type", "password");
    urlencoded.append("userName", `${environment.mercury.api.username}`);
    urlencoded.append("password", `${environment.mercury.api.password}`);
 
    return this.httpClient.post(`${environment.mercury.api.address}/token`, urlencoded, { headers: customHeaders })
  }

  OptInOut(model: OptInOutModel, token: any) : Observable<any>{

    const header = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `bearer ${token.access_token}`);

   return this.httpClient.post(`${environment.mercury.api.address}/api/OptInOut/${this.broker.brokerId}`, model, { headers: header })

  }

  getCustomerByPortfolioCode(portfolioCode: string): Observable<PolicyHolder>{

    return this.httpClient.get<PolicyHolder>(`${environment.mercury.heca.address}/customer/byportfolio/${portfolioCode}`)

  }
}
